import { RepositoryFactory } from './../../repositories/RepositoryFactory.js';

const userRepository = RepositoryFactory.get('userAdmin');

export default async function auth({ to, next, store }) {
    const loginQuery = { path: "/admin/" };
    const user = await userRepository.getAdminAuth();
    if (user.data.user) {
        return next(loginQuery);
    }
    next();
}
